
export { ShoppingBagButton } from "/codebuild/output/src4122767702/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"